import React from 'react'
import { StatementProvider } from './StatementContext'
export default ({ children }) => <StatementProvider>{children}</StatementProvider>
